<div class="login-page-container">
  <app-login class="z-index--1"></app-login>
  <app-circles-background class="circle-background"></app-circles-background>
</div>
